module.exports = __webpack_public_path__ + "img/1.20.B.0f503c6d.png";